export class MemberUser{
    public MemberUserId:string;
    public Name:string;
    public Description:string;
    public PreferredLanguageId:number;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/member-user.ts